import { callExternalApi } from './axios.service'
import { isEmptyString } from '../string-utils'

export interface Server {
  url: string
  version: string
}

export type AxiosFetcherKey = [
  server: Server,
  identifier: string | null,
  route: string,
  accessToken: string | null,
  params: Record<string, any> | null
] | null

export const axiosFetcher = async (key: AxiosFetcherKey): Promise<any> => {
  if (key == null) return

  const [server, identifier, route, accessToken, params] = key

  let url = server.url
  if (!isEmptyString(identifier)) {
    url += `/${identifier}`
  }
  url += '/api'
  if (!isEmptyString(server.version)) {
    url += `/${server.version}`
  }
  url += `/${route}`

  const headers: Record<string, string> = {
    'content-type': 'application/json',
  }

  // Add access token to request headers (Authorization)
  if (!isEmptyString(accessToken)) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  // Auto-complete any request parameters (prefixed with 'axios' in their names)
  if (params?.['axios-timestamp'] != null) {
    params.timestamp = new Date().toISOString()
    delete params['axios-timestamp']
  }

  const config = { url, method: 'GET', headers, params }

  const { data, error } = await callExternalApi({ config })

  if (error != null) {
    console.error(`axios-fetcher: ${error.message}`)
    return
  }

  if (data?.data != null) {
    const variableTypeData = data.data
    return (typeof variableTypeData === 'string') ? JSON.parse(variableTypeData) : variableTypeData
  }

  if (data != null && (Array.isArray(data) || typeof data === 'object')) {
    return data
  }

  console.error('axios-fetcher: unknown response format')
}
